module.exports = __webpack_public_path__ + "img/na.cf3ee30b.png";